// extracted by css-extract-rspack-plugin
export default {"segmentedContainer":"segmented-container--wgQRIbXo3Yxon0zf","abstractLinkLoading":"abstract-link-loading--_9YusGCFTp4sV_C8"};